import { createSelector } from 'reselect';
import { mapAppointment } from '../utils/mapAppointment';

export const getAppointmentsByQueueType = state => {
  const archiveOpened = state.queues.common.appointmentInfo.isArchiveOpened;

  return archiveOpened
    ? state.queues.archive.archiveAppointments
    : state.queues.schedule.appointments;
};

const getAppointmentById = appointmentId => createSelector(
  getAppointmentsByQueueType,
  ({ entities }) => entities[appointmentId],
);

export const makeMappedAppointmentSelector = (appointmentId) => createSelector(
  getAppointmentById(appointmentId),
  appointment => mapAppointment(appointment),
);
